module.exports = __webpack_public_path__ + "img/img_product_07_03@2x.db367ef8.png";